var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileSignature(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M9.212 18.568a.445.445 0 00-.406-.255.436.436 0 00-.4.242l-.307.6c-.254.499-1 .443-1.177-.082L6.25 17.1l-.424 1.245a1.72 1.72 0 01-1.637 1.154h-.495c-.353 0-.638-.28-.638-.625s.285-.625.638-.625h.495c.193 0 .364-.12.425-.3l.726-2.134a.958.958 0 01.91-.64c.413 0 .778.257.91.64l.553 1.627c.789-.632 2.16-.379 2.636.553a.452.452 0 00.374.245v-3.208l5.11-4.965V8.25h-5.43a.952.952 0 01-.959-.938V2H1.458a.946.946 0 00-.958.938v18.125c0 .519.427.937.958.937h13.417a.946.946 0 00.958-.938V19.5l-5.11-.004a1.718 1.718 0 01-1.511-.928zm6.621-11.806c0-.246-.1-.485-.28-.66l-3.908-3.829a.974.974 0 00-.68-.273h-.243v5h5.111v-.238zM12 15.553v2.697h2.755l6.456-6.359L18.5 9.24 12 15.553zm11.202-7.017l-1.273-1.245a1.033 1.033 0 00-1.437 0l-1.089 1.065 2.71 2.651 1.089-1.064a.98.98 0 000-1.407z"
  }))));
}

export default SvgFileSignature;